import { render, staticRenderFns } from "./CommandList.vue?vue&type=template&id=462beeab"
import script from "./CommandList.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommandList.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports